module.exports = __webpack_public_path__ + "img/intercom-awaiting-installation.95372209.jpg";